import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Questions } from 'src/Models/Questions';

@Component({
  selector: 'tpl-checkboxes',
  templateUrl: './tpl-checkboxes.component.html',
  styleUrls: ['./tpl-checkboxes.component.sass']
})
export class TplCheckboxesComponent implements OnInit {
  @Input() form: FormGroup;
  @Input() objColor: any;
  @Input() question: Questions;

  @Output() nextStep = new EventEmitter<string>();
  @Output() hiddenShowTitle = new EventEmitter<boolean>();

  checkboxes: string[] = [];

  constructor() { }

  ngOnInit(): void {
  }

  checkboxValue(event, value) {
    const checkValue = event.target.checked;
    let valueMultipleQuestion = this.form.get('value').value;

    if (valueMultipleQuestion == null && checkValue) {
      valueMultipleQuestion = [value];
    } else {
      if (checkValue) valueMultipleQuestion.push(value);
      else valueMultipleQuestion = valueMultipleQuestion.filter(x => x != value);
    }
    this.form.get('value').setValue(valueMultipleQuestion);
  }

  checkboxValueInput(question, tagInput){
    const valueInput = `[Other]${tagInput.value}`
    const indexValue = this.checkboxes.findIndex(x => x.includes(question.id_question.toString()));
    const currentValue = `${question.id_question}-${valueInput}`;
    let valueMultipleQuestion = this.form.get('value').value;

    if(indexValue != -1){
      const lastValue = this.checkboxes[indexValue].replace(`${question.id_question}-`,'');
      this.checkboxes[indexValue] = currentValue;
      if(valueMultipleQuestion == null) valueMultipleQuestion = [valueInput];
      else {
        valueMultipleQuestion = valueMultipleQuestion.filter(x => x != lastValue);
        valueMultipleQuestion.push(valueInput);
      }
    }else{
      if(valueMultipleQuestion == null) valueMultipleQuestion = [valueInput];
      else{
      valueMultipleQuestion.push(valueInput);
    }
      this.checkboxes.push(currentValue)
    }
    this.form.get('value').setValue;
  }

  checkboxOthersSelect(question, tagCheckbox){
    const checkValue = tagCheckbox.checked;
    let valueMultipleQuestion = this.form.get('value').value;
    const indexValue = this.checkboxes.findIndex(x => x.includes(question.id_question.toString()));
    const lastValue = indexValue != -1 ? this.checkboxes[indexValue] : null;
    
    if (valueMultipleQuestion != null && !checkValue && lastValue != null) {
      valueMultipleQuestion = valueMultipleQuestion.filter(x => x != lastValue.replace(`${question.id_question}-`,''));
      this.form.get('value').setValue;
    }
  }

  finishQuestion() {
    this.nextStep.emit('')
  }
}
